document.addEventListener("DOMContentLoaded", function () {
  function initMegamenu() {
    const megamenuButtons = document.querySelectorAll(".megamenu-button");
    const megamenuCards = document.querySelectorAll(".megamenu-card");
    const linkButtons = document.querySelectorAll(".link-level-1 .button");
    const linkLists = document.querySelectorAll(".linklist-main-2");

    function resetActiveStates() {
      megamenuButtons.forEach((b) => b.classList.remove("active"));
      megamenuCards.forEach((c) => c.classList.remove("active"));
      linkLists.forEach((l) => l.classList.remove("active"));
      linkButtons.forEach((b) => b.classList.remove("active"));
      document
        .querySelectorAll(".link-level-1")
        .forEach((el) => el.classList.remove("active"));
    }

    function setDefaultActive() {
      resetActiveStates();

      const firstButton = megamenuButtons[0];
      const firstCard = megamenuCards[0];

      if (firstButton && firstCard) {
        firstButton.classList.add("active");
        firstCard.classList.add("active");

        const firstLinkButton = firstCard.querySelector(
          ".link-level-1 .button"
        );
        const firstLinkList = firstCard.querySelector(".linklist-main-2");
        const parentGroup = firstLinkButton?.closest(".link-level-1");

        if (firstLinkButton) firstLinkButton.classList.add("active");
        if (parentGroup) parentGroup.classList.add("active");
        if (firstLinkList) firstLinkList.classList.add("active");
      }
    }

    function fadeIn(elem, callback) {
      let opacity = 0;
      elem.style.display = "flex";
      elem.style.opacity = opacity;

      if (window.innerHeight > 768) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
      setTimeout(() => {
        elem.classList.add("active");
      }, 500);

      function animate() {
        opacity += 0.05;
        elem.style.opacity = opacity;
        if (opacity < 1) {
          requestAnimationFrame(animate);
        } else {
          elem.style.opacity = 1;
          if (typeof callback === "function") callback();
        }
      }
      requestAnimationFrame(animate);
    }

    function fadeOut(elem, callback) {
      let opacity = 1;

      function animate() {
        opacity -= 1;
        if (opacity < 0) opacity = 0;

        elem.style.opacity = opacity;
        if (opacity > 0) {
          requestAnimationFrame(animate);
        } else {
          elem.style.opacity = 0;
          elem.style.display = "none";
          elem.classList.remove("active");
          document.body.style.overflow = "auto";
          resetActiveStates();
          if (typeof callback === "function") callback();
        }
      }
      requestAnimationFrame(animate);
    }

    megamenuButtons.forEach((button) => {
      const card = button.nextElementSibling;

      button.addEventListener("mouseenter", () => {
        resetActiveStates();

        button.classList.add("active");
        if (card && card.classList.contains("megamenu-card")) {
          card.classList.add("active");

          const firstLinkButton = card.querySelector(".link-level-1 .button");
          const firstLinkList = card.querySelector(".linklist-main-2");
          const parentGroup = firstLinkButton?.closest(".link-level-1");

          if (firstLinkButton) firstLinkButton.classList.add("active");
          if (parentGroup) parentGroup.classList.add("active");
          if (firstLinkList) firstLinkList.classList.add("active");
        }
      });
    });

    linkButtons.forEach((button) => {
      const list = button.nextElementSibling;

      button.addEventListener("mouseenter", () => {
        const currentCard = button.closest(".megamenu-card");
        const parentGroup = button.closest(".link-level-1");

        if (currentCard) {
          currentCard
            .querySelectorAll(".link-level-1")
            .forEach((group) => group.classList.remove("active"));
          currentCard
            .querySelectorAll(".link-level-1 .button, .linklist-main-2")
            .forEach((el) => el.classList.remove("active"));

          button.classList.add("active");

          if (parentGroup) parentGroup.classList.add("active");

          if (list && list.classList.contains("linklist-main-2")) {
            list.classList.add("active");
          }
        }
      });
    });

    let currentOpenMenu = null;

    document.querySelectorAll(".menu-toggle-button").forEach((button) => {
      button.addEventListener("click", function () {
        const targetSelector = this.getAttribute("data-target");
        const elem = document.querySelector(targetSelector);
        if (!elem) return;

        const computedStyle = getComputedStyle(elem);
        const isHidden =
          computedStyle.display === "none" ||
          parseFloat(computedStyle.opacity) === 0;

        if (isHidden) {
          fadeIn(elem, () => {
            setDefaultActive();
          });
          currentOpenMenu = elem;
        } else {
          fadeOut(elem);
          currentOpenMenu = null;
        }
      });
    });

    document.querySelectorAll(".megamenu-overlay").forEach((overlay) => {
      overlay.addEventListener("click", function () {
        if (currentOpenMenu) {
          fadeOut(currentOpenMenu);
          currentOpenMenu = null;
        }
      });
    });

    // Set initial state on normal page load
    setDefaultActive();
  }

  // Run on initial page load
  initMegamenu();

  // Listen for Shopify section load event (theme editor)
  document.addEventListener("shopify:section:load", function () {
    initMegamenu();
  });

  window.addEventListener("resize", () => {
    const isMegamenuOpen =
      document.querySelector(".megamenu-overlay.active") !== null;

    if (isMegamenuOpen) {
      if (window.innerHeight > 768) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    }
  });

  
// Toggle mobile menu and reset all if closing
document.querySelector('.nav-center').addEventListener('click', function (event) {
  event.preventDefault();

  const isActive = document.body.classList.contains('mobilemenuIsactive');
  document.body.classList.toggle('mobilemenuIsactive');

  // If menu is being closed, reset all open states
  if (isActive) {
    // Close all open submenus
    document.querySelectorAll('.mobile-menu-level-1.open').forEach(el => {
      el.classList.remove('open');
    });

    // Close all open accordion items
    document.querySelectorAll('.accordion-item.open').forEach(item => {
      item.classList.remove('open');
      const content = item.querySelector('.accordion-content');
      if (content) content.style.maxHeight = null;
    });
  }
});

// Handle submenu "next" click
document.querySelectorAll('.toNext .svg-wrapper').forEach(link => {
  link.addEventListener('click', function(event) {
    event.preventDefault();
    const parentLi = this.closest('.mobile-menu-level-1');
    parentLi.classList.toggle('open');
  });
});

// Handle submenu "back" click
document.querySelectorAll('.getBack').forEach(link => {
  link.addEventListener('click', function(event) {
    event.preventDefault();
    const parentLi = this.closest('.mobile-menu-level-1');
    parentLi.classList.toggle('open');
  });
});

// Accordion behavior with smooth scroll
document.querySelectorAll('.accordion-header').forEach(header => {
  header.addEventListener('click', function () {
    const item = this.parentElement;
    const content = item.querySelector('.accordion-content');

    const isOpen = item.classList.contains('open');

    // Close all accordion items
    document.querySelectorAll('.accordion-item').forEach(i => {
      i.classList.remove('open');
      i.querySelector('.accordion-content').style.maxHeight = null;
    });

    // Open the clicked item
    if (!isOpen) {
      item.classList.add('open');
      content.style.maxHeight = content.scrollHeight + 'px';

      // Smooth scroll to the opened item
      item.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});


});

function setAdjustedVh() {
  const docEl = document.documentElement;
  const vv = window.visualViewport;

  let height;

  if (vv) {
    const ua = navigator.userAgent;
    const isIOS = /iP(hone|ad|od)/.test(ua);
    const isChromeIOS = /CriOS/.test(ua);

    if (isIOS) {
      if (isChromeIOS) {
        // ✅ iOS Chrome: use window.innerHeight to avoid bottom white gap
        height = window.innerHeight;
      } else {
        // iOS Safari: normalize with offsetTop
        const candidate = vv.height + vv.offsetTop;
        height = Math.min(candidate, window.innerHeight);
      }
    } else {
      // Android / desktop
      height = vv.height;
    }
  } else {
    height = window.innerHeight;
  }

  const vh = height * 0.01;

  // Calculate nav offset
  const isolate = document.querySelector('.section-mobile-navigation .isolate');
  const offset = isolate ? isolate.getBoundingClientRect().height : 0;

  // iOS safe-area inset
  const safeInset = parseInt(getComputedStyle(docEl).getPropertyValue("env(safe-area-inset-bottom)") || 0, 10) || 0;

  docEl.style.setProperty('--vh', `${vh}px`);
  docEl.style.setProperty('--nav-offset', `${offset + safeInset}px`);
}

setAdjustedVh();

window.visualViewport?.addEventListener('resize', setAdjustedVh, { passive: true });
window.visualViewport?.addEventListener('scroll', setAdjustedVh, { passive: true });
window.addEventListener('resize', setAdjustedVh, { passive: true });
window.addEventListener('orientationchange', setAdjustedVh);



// function setAdjustedVh() {
//   const vh = window.visualViewport ? window.visualViewport.height * 0.01 : window.innerHeight * 0.01;
//   const isolate = document.querySelector('.section-mobile-navigation .isolate');
//   const offset = isolate ? isolate.getBoundingClientRect().height : 0;

//   document.documentElement.style.setProperty('--vh', `${vh}px`);
//   document.documentElement.style.setProperty('--nav-offset', `${offset}px`);
// }

// setAdjustedVh();
// window.visualViewport?.addEventListener('resize', setAdjustedVh);
// window.addEventListener('resize', setAdjustedVh);


// function setAdjustedVh() {
//   const vh = window.innerHeight * 0.01;
//   const isolate = document.querySelector('.section-mobile-navigation .isolate');
//   const offset = isolate ? isolate.getBoundingClientRect().height : 0;

//   document.documentElement.style.setProperty('--vh', `${vh}px`);
//   document.documentElement.style.setProperty('--nav-offset', `${offset}px`);
// }
// setAdjustedVh();
// window.addEventListener('resize', setAdjustedVh);